/* eslint-disable no-nested-ternary */
import { breakpoints } from '../../../../utilities'
import type { Tokens } from '../../../../theming/types'
import type { BaseMenuItemProps } from '..'

export default (config: {
  props: Pick<
    BaseMenuItemProps,
    | 'active'
    | 'description'
    | 'disabled'
    | 'hasStartElementIcon'
    | 'isSelectionMenu'
    | 'startElement'
    | 'endElement'
    | 'selected'
  >
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      content: {
        ...(props.selected ? tokens.fontItemSelected : tokens.fontBodyS),
        background: props.active ? tokens.itemBgColorHover : 'transparent',
        color: props.disabled
          ? tokens.fontColorDisabled
          : tokens.fontColorDefault,
        textTransform: 'none',
        minHeight: '32px',
        borderRadius: tokens.radiusSizeXS,
        paddingBlock: tokens.spacingGap100,
        paddingInlineStart: tokens.spacingGap200,
        paddingInlineEnd:
          props.endElement || props.isSelectionMenu
            ? tokens.spacingGap100
            : tokens.spacingGap200,
        marginInline: tokens.spacingGap100,
        width: `calc(100% - ${tokens.spacingGap100} * 2)`,

        [breakpoints.lessThan(breakpoints.Sizes.ExtraSmall)]: {
          minHeight: '48px',
        },

        ...(!props.disabled && {
          '&:hover': {
            background: tokens.itemBgColorHoverSubtle,
          },

          '&:active': {
            background: tokens.itemBgColorActiveSubtle,
          },
        }),
      },

      startElement: {
        alignSelf: 'flex-start',
        marginInlineEnd: tokens.spacingGap100,
        color: props.disabled
          ? tokens.iconColorDisabled
          : tokens.iconColorDefault,

        [breakpoints.lessThan(breakpoints.Sizes.ExtraSmall)]: {
          marginBlockStart: props.description ? 0 : '6px',
        },
      },

      endElement: {
        alignSelf: 'flex-start',
        ...tokens.fontBodyS,
        color: props.disabled
          ? tokens.iconColorDisabled
          : tokens.iconColorDefault,

        '& svg': {
          height: '20px !important',
          width: '20px !important',
        },

        [breakpoints.lessThan(breakpoints.Sizes.ExtraSmall)]: {
          marginBlockStart: props.description ? 0 : '6px',
        },
      },

      text: {
        // This originates in Menu.Group. It checks to see if the Menu.Group contains startElementIcons.
        marginInlineStart:
          props.hasStartElementIcon && !props.startElement
            ? // spacing needs to be 28px to align with the other Menu.Group items
              `calc(${tokens.spacingGap250} + ${tokens.spacingGap100})`
            : undefined,
      },

      badge: {
        insetBlockStart: `-${tokens.spacingGap150}`,
      },
    },

    selectedOption: {
      iconWrap: {
        marginInlineStart: `-${tokens.spacingGap150}`,
        marginInlineEnd: tokens.spacingGap150,
      },
    },
  } as const
}
